var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Image Unavailable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.imageNotFound{fill-rule:evenodd;clip-rule:evenodd;fill:#b9c6d4;}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "imageNotFound",
    d: "M0,0v38h48V0H0ZM9.71,36l10.09-17.96,6.63,11.84.76,1.36.92-1.25,3.79-5.16,6.38,11.17H9.71ZM45.98,36.01h-5.42l-7.71-13.5-.76-1.34-.91,1.24-3.78,5.15-6.74-12.04-.87-1.56-.87,1.55-11.51,20.49H2V2h43.98v34.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "imageNotFound",
    d: "M37.5,8c-2.49,0-4.5,2.01-4.5,4.5s2.01,4.5,4.5,4.5,4.5-2.01,4.5-4.5-2.01-4.5-4.5-4.5ZM37.5,15c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUnavailable);
export default __webpack_public_path__ + "static/media/image-unavailable.544d39e93588ba549ffd4d4d089e18dd.svg";
export { ForwardRef as ReactComponent };